module.exports = __webpack_public_path__ + "img/js.71622a37.svg";